module.exports = __webpack_public_path__ + "img/demo-photo05.952f5b17.jpg";